import { render, staticRenderFns } from "./table-tasks.vue?vue&type=template&id=bc4e0974&"
import script from "./table-tasks.vue?vue&type=script&lang=js&"
export * from "./table-tasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports